import React from 'react';
import bannerImage from '../../../../assets/images/theme_2.svg';

import { FaCheck } from 'react-icons/fa';
import UseSignUpPage from './useSignUpPage';
import Select from 'react-select';
import SignUpPageHelmet from '../../../HelmetComponents/SignUpPageHelmet';

const SignUpPage: React.FC = () => {
  const {
    handleBack,
    handleSubmit,
    handleNext,
    handleChange,
    states,
    handleChangeBusineType,
    handleChangeCustomerGroup,
  } = UseSignUpPage();

  return (
    <>
      <SignUpPageHelmet />
      <div className='flex items-center justify-center bg-gray-100 px-6 py-12 sm:py-12 md:py-16 lg:py-16'>
        <div className='bg-white w-full max-w-2xl rounded-lg sm:rounded-lg md:rounded-xl xl:rounded-xl shadow-lg overflow-hidden min-h-96 pb-6 sm:pb-6 md:pb-0 lg:pb-0'>
          {/* Top Banner */}
          <div className='px-0 sm:px-0 md:px-20 lg:px-20 bg-[#D9A448]'>
            <img src={bannerImage} alt='Manikchand Sign' className='w-full h-full object-cover' />
          </div>

          {/* Form Section */}
          <div className='p-2 py-2 sm:p-2 sm:py-2 md:p-6 md:py-6 lg:p-6 lg:py-6'>
            <h1
              className='font-rubik text-center text-xl sm:text-xl md:text-2xl lg:text-2xl 
                            py-4 sm:py-4 md:py-0 lg:py-0
                            text-[#552B18] sm:text-[#552B18] md:text-[#552B18] lg:text-black'
            >
              {states.stepTitle}
            </h1>

            {/* Stepper - Responsive*/}
            <div className='w-full px-2 sm:px-2 md:px-3 lg:px-4 mb-4 sm:mb-4 md:mb-0 lg:mb-0 py-0 sm:py-0 md:py-6 lg:py-6 '>
              {/* Desktop Stepper */}
              <div className='hidden sm:flex justify-between items-center font-poppins'>
                {[1, 2, 3].map((s, i) => (
                  <React.Fragment key={s}>
                    <div className='flex justify-between items-center flex-2 pl-1'>
                      <div
                        className={`w-8 h-8 rounded-full flex items-center justify-center text-sm sm:text-sm md:text-base lg:text-base font-medium
                                                ${
                                                  states.step === s
                                                    ? 'bg-[#552A16] text-white opacity-100'
                                                    : states.step > s
                                                      ? 'bg-[#552A16] text-white opacity-50'
                                                      : 'bg-[#ECE0BD] text-black opacity-100'
                                                }
                                            `}
                      >
                        {states.step > s ? <FaCheck size={14} /> : s}
                      </div>
                      <p className='text-sm sm:text-sm md:text-base lg:text-base px-2'>
                        {states.step === s ? 'In progress' : states.step > s ? 'Completed' : 'Pending'}
                      </p>
                    </div>
                    {i < 2 && (
                      <div className={`flex-1 h-1 rounded ${states.step > s ? 'bg-[#552A16]' : 'bg-[#ECE0BD]'}`}></div>
                    )}
                  </React.Fragment>
                ))}
              </div>

              {/* Mobile Stepper */}
              <div className='flex sm:hidden justify-center items-center gap-1 -mt-1'>
                {states.stepsMobileArr.map(s => (
                  <div key={s.id} className='flex items-center gap-1 px-2'>
                    {/* Circle */}
                    <div
                      className={`w-6 h-6 rounded-full flex items-center justify-center text-sm font-poppins
                                         ${
                                           states.step === s.id
                                             ? 'bg-[#552A16] text-white'
                                             : states.step > s.id
                                               ? 'bg-[#B49A7D] text-white'
                                               : 'bg-[#ECE0BD] text-black'
                                         }`}
                    >
                      {states.step > s.id ? <FaCheck size={12} /> : s.id}
                    </div>
                    {/* Label only for active states.step */}
                    {states.step === s.id && (
                      <span className='ml-2 text-base font-poppins text-black whitespace-nowrap'>{s.label}</span>
                    )}
                  </div>
                ))}
              </div>
            </div>

            <div className='px-2 sm:px-2 md:px-4 lg:px-6'>
              <form className='px-2 pb-0 sm:px-2 md:px-6 md:pb-10 lg:px-6 lg:pb-10'>
                {states.step === 1 && (
                  <>
                    {/* <h2 className="hidden sm:hidden md:flex lg:flex text-xl text-black mb-4 font-poppins">
                                        Personal Information
                                    </h2> */}
                    <div className='mb-4'>
                      <label className='block mb-1 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                        Full Name
                        <span className='text-red-600 font-poppins'>*</span>
                      </label>
                      <input
                        type='text'
                        name='fullName'
                        placeholder='Enter full name'
                        value={states.formData.fullName}
                        onChange={handleChange}
                        className='w-full border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg sm:rounded-lg md:rounded-xl xl:rounded-xl font-poppins text-sm sm:text-sm md:text-base lg:text-base'
                      />
                      {states.errors.fullName && (
                        <p className='text-red-500 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                          {states.errors.fullName}
                        </p>
                      )}
                    </div>
                    <div className='mb-2 sm:mb-2 md:mb-4 lg:mb-4 '>
                      <label className='block mb-0 sm:mb-0 md:mb-0 lg:mb-1 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                        Mobile Number
                        <span className='text-red-600 font-poppins'>*</span>
                      </label>
                      <div className='flex border border-gray-300 rounded-lg sm:rounded-lg md:rounded-xl xl:rounded-xl overflow-hidden font-poppins text-sm sm:text-sm md:text-base lg:text-base'>
                        <span className='bg-gray-100 px-2 py-2 sm:px-2 sm:py-2 md:px-2 md:py-3 lg:px-3 lg:py-4 border-r border-gray-300 text-gray-700 font-poppins'>
                          +91
                        </span>
                        <input
                          type='text'
                          name='mobile'
                          maxLength={10}
                          placeholder='Enter mobile number'
                          value={states.formData.mobile}
                          onChange={handleChange}
                          className='flex-1 px-2 py-2 sm:px-2 sm:py-2 md:px-2 md:py-3 lg:px-3 lg:py-4 outline-none font-poppins'
                        />
                      </div>
                      {states.errors.mobile && (
                        <p className='text-red-500 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                          {states.errors.mobile}
                        </p>
                      )}
                    </div>
                  </>
                )}

                {states.step === 2 && (
                  <>
                    {/* <h2 className="hidden sm:hidden md:flex lg:flex text-xl text-black mb-4 font-poppins">
                                        Location Information
                                    </h2> */}

                    <div className='mb-4'>
                      <label className='block mb-1 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                        Shop Name
                        <span className='text-red-600 font-poppins'>*</span>
                      </label>
                      <input
                        type='text'
                        name='shopName'
                        placeholder='Enter shop name'
                        className='w-full border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg sm:rounded-lg md:rounded-xl xl:rounded-xl font-poppins text-sm sm:text-sm md:text-base lg:text-base'
                        value={states.formData.shopName}
                        onChange={handleChange}
                      />
                      {states.errors.shopName && (
                        <p className='text-red-500 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                          {' '}
                          {states.errors.shopName}
                        </p>
                      )}
                    </div>
                    <div className='mb-4'>
                      <label className='block mb-1 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                        Address Line-1
                        <span className='text-red-600 font-poppins'>*</span>
                      </label>
                      <input
                        type='text'
                        name='address1'
                        placeholder='Enter address line-1'
                        value={states.formData.address1}
                        onChange={handleChange}
                        className='w-full border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg sm:rounded-lg md:rounded-xl xl:rounded-xl text-sm sm:text-sm md:text-base lg:text-base'
                      />
                      {states.errors.address1 && (
                        <p className='text-red-500 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                          {states.errors.address1}
                        </p>
                      )}
                    </div>
                    <div className='mb-4'>
                      <label className='block mb-1 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                        Address Line-2
                        <span className='text-red-600 font-poppins'>*</span>
                      </label>
                      <input
                        type='text'
                        name='address2'
                        placeholder='Enter address line-2'
                        value={states.formData.address2}
                        onChange={handleChange}
                        className='w-full border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg sm:rounded-lg md:rounded-xl xl:rounded-xl text-sm sm:text-sm md:text-base lg:text-base'
                      />
                      {states.errors.address2 && (
                        <p className='text-red-500 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                          {states.errors.address2}
                        </p>
                      )}
                    </div>

                    <div className='mb-4'>
                      <label
                        className='block mb-1 text-sm sm:text-sm md:text-base lg:text-base font-poppins'
                        htmlFor='city'
                      >
                        City <span className='text-red-600 font-poppins'>*</span>
                      </label>
                      <input
                        type='text'
                        name='city'
                        placeholder='Enter city'
                        value={states.formData.city}
                        onChange={handleChange}
                        className='w-full border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg sm:rounded-lg md:rounded-xl xl:rounded-xl text-sm sm:text-sm md:text-base lg:text-base'
                      />
                      {states.errors.city && (
                        <p className='text-red-500 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                          {states.errors.city}{' '}
                        </p>
                      )}
                    </div>
                    <div className='mb-4'>
                      <label
                        className='block mb-1 text-sm sm:text-sm md:text-base lg:text-base font-poppins'
                        htmlFor='city'
                      >
                        State<span className='text-red-600 font-poppins'>*</span>
                      </label>
                      <select
                        name='state'
                        value={states.formData.state}
                        onChange={handleChange}
                        className='w-full bg-white border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg sm:rounded-lg md:rounded-xl xl:rounded-xl text-sm sm:text-sm md:text-base lg:text-base font-poppins'
                      >
                        <option value='' disabled>
                          Select state
                        </option>
                        {states.stateList &&
                          states.stateList.map(state => (
                            <option key={state} value={state}>
                              {state}
                            </option>
                          ))}
                      </select>
                      {states.errors.state && (
                        <p className='text-red-500 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                          {states.errors.state}
                        </p>
                      )}
                    </div>

                    <div className='mb-4'>
                      <label
                        className='block mb-1 text-sm sm:text-sm md:text-base lg:text-base font-poppins'
                        htmlFor='city'
                      >
                        Country <span className='text-red-600 font-poppins'>*</span>
                      </label>
                      <select
                        name='country'
                        value={states.formData.country}
                        onChange={handleChange}
                        disabled
                        className='w-full bg-gray-100 border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg sm:rounded-lg md:rounded-xl xl:rounded-xl text-sm sm:text-sm md:text-base lg:text-base font-poppins'
                      >
                        {states.countryList &&
                          states.countryList.map(country => (
                            <option key={country.name} value={country.name}>
                              {country.name}
                            </option>
                          ))}
                      </select>
                      {states.errors.country && (
                        <p className='text-red-500 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                          {states.errors.country}
                        </p>
                      )}
                    </div>

                    <div className='mb-4'>
                      <label className='block mb-1 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                        Pincode
                        <span className='text-red-600 font-poppins'>*</span>
                      </label>
                      <input
                        type='text'
                        name='pincode'
                        placeholder='Enter pincode'
                        value={states.formData.pincode}
                        onChange={handleChange}
                        maxLength={6}
                        inputMode='numeric'
                        pattern='\d*'
                        className='w-full border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg sm:rounded-lg md:rounded-xl xl:rounded-xl text-sm sm:text-sm md:text-base lg:text-base'
                      />
                      {states.errors.pincode && (
                        <p className='text-red-500 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                          {states.errors.pincode}
                        </p>
                      )}
                    </div>
                  </>
                )}

                {states.step === 3 && (
                  <>
                    {/* <h2 className="hidden sm:hidden md:flex lg:flex text-xl text-black mb-4 font-poppins">
                                        Other Information
                                    </h2> */}
                    <div className='flex gap-4 mb-4'>
                      <div className='w-1/2'>
                        <label className='text-sm sm:text-sm md:text-base lg:text-base mb-1 font-poppins'>
                          Opening Time
                        </label>
                        <input
                          type='time'
                          name='openingTimeFrom'
                          value={states.formData.openingTimeFrom}
                          onChange={handleChange}
                          className='w-full border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg sm:rounded-lg md:rounded-xl xl:rounded-xl text-sm sm:text-sm md:text-base lg:text-base font-poppins'
                        />
                        {states.errors.openingTimeFrom && (
                          <p className='text-red-500 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                            {states.errors.openingTimeFrom}
                          </p>
                        )}
                      </div>
                      <div className='w-1/2'>
                        <label className='text-sm sm:text-sm md:text-base lg:text-base mb-1 font-poppins'>
                          Closing Time
                        </label>
                        <input
                          type='time'
                          name='openingTimeTo'
                          value={states.formData.openingTimeTo}
                          onChange={handleChange}
                          className='w-full border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg sm:rounded-lg md:rounded-xl xl:rounded-xl text-sm sm:text-sm md:text-base lg:text-base font-poppins'
                        />
                        {states.errors.openingTimeTo && (
                          <p className='text-red-500 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                            {states.errors.openingTimeTo}
                          </p>
                        )}
                      </div>
                    </div>
                    <div>
                      <label className='text-sm sm:text-sm md:text-base lg:text-base block mb-1 font-poppins'>
                        Preferable Delivery Time
                      </label>
                      <div className='flex gap-4 mb-4 sm:mb-4 md:mb-6 lg:mb-6'>
                        <div className='w-1/2'>
                          <input
                            type='time'
                            name='deliveryTimeFrom'
                            value={states.formData.deliveryTimeFrom}
                            onChange={handleChange}
                            className='w-full border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 text-sm sm:text-sm md:text-base lg:text-base rounded-lg sm:rounded-lg md:rounded-xl xl:rounded-xl font-poppins'
                          />
                          {states.errors.deliveryTimeFrom && (
                            <p className='text-red-500 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                              {states.errors.deliveryTimeFrom}
                            </p>
                          )}
                        </div>
                        <div className='w-1/2'>
                          {/* <label className="text-sm sm:text-sm md:text-base lg:text-base block mb-1 font-poppins">
                                                To
                                            </label> */}
                          <input
                            type='time'
                            name='deliveryTimeTo'
                            value={states.formData.deliveryTimeTo}
                            onChange={handleChange}
                            className='w-full border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg sm:rounded-lg md:rounded-xl xl:rounded-xl text-sm sm:text-sm md:text-base lg:text-base font-poppins'
                          />
                          {states.errors.deliveryTimeTo && (
                            <p className='text-red-500 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                              {states.errors.deliveryTimeTo}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className='mb-4 sm:mb-4 md:mb-6 lg:mb-6'>
                      <label
                        className='block mb-1 text-sm sm:text-sm md:text-base lg:text-base font-poppins'
                        htmlFor='city'
                      >
                        Customer Group
                        <span className='text-red-600 font-poppins'>*</span>
                      </label>
                      <Select
                        className='basic-single'
                        classNamePrefix='select'
                        value={states.selectedCustomerGroup}
                        onChange={handleChangeCustomerGroup}
                        isClearable={true}
                        isSearchable={true}
                        name='customerGroup'
                        options={states.customerGroupOptions}
                        placeholder='Select Customer Group'
                        isDisabled={false}
                        isLoading={false}
                        isRtl={false}
                      />
                      {states.errors.customerGroup && (
                        <p className='text-red-500 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                          {states.errors.customerGroup}
                        </p>
                      )}
                    </div>

                    <div className='mb-4 sm:mb-4 md:mb-6 lg:mb-6'>
                      <label
                        className='block mb-1 text-sm sm:text-sm md:text-base lg:text-base font-poppins'
                        htmlFor='city'
                      >
                        Business Type
                        <span className='text-red-600 font-poppins'>*</span>
                      </label>
                      <Select
                        className='basic-single'
                        classNamePrefix='select'
                        value={states.selectedBusinessType}
                        onChange={handleChangeBusineType}
                        isClearable={true}
                        isSearchable={true}
                        name='businessType'
                        options={states.businessTypeOptions}
                        placeholder='Select Business Type'
                        isDisabled={false}
                        isLoading={false}
                        isRtl={false}
                      />
                      {states.errors.businessType && (
                        <p className='text-red-500 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                          {states.errors.businessType}
                        </p>
                      )}
                    </div>

                    <div className='flex items-center mb-4 sm:mb-4 md:mb-6 lg:mb-6'>
                      <input
                        type='checkbox'
                        id='gstRegistered'
                        name='gstRegistered'
                        checked={states.formData.gstRegistered}
                        onChange={handleChange}
                        className='mr-2 sm:mr-2 md:mr-3 lg:mr-4 min-h-5 min-w-6 sm:min-h-5 sm:min-w-6 md:min-h-6 md:min-w-7 lg:min-h-6 lg:min-w-7'
                      />
                      <label
                        htmlFor='gstRegistered'
                        className='mb-1 font-poppins text-sm sm:text-sm md:text-base lg:text-base'
                      >
                        GST Registered?
                      </label>
                    </div>
                    {states.showGstNumberInput && (
                      <div className='mb-4'>
                        <label className='block mb-1 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                          GST Number
                          <span className='text-red-600 font-poppins'>*</span>
                        </label>
                        <input
                          type='text'
                          name='gst_number'
                          placeholder='Enter GST Number'
                          value={states.formData.gst_number}
                          onChange={handleChange}
                          maxLength={15}
                          className='w-full border border-gray-300 p-2 sm:p-2 md:p-3 lg:p-3 rounded-lg sm:rounded-lg md:rounded-xl xl:rounded-xl text-sm sm:text-sm md:text-base lg:text-base'
                        />
                        {states.errors.gst_number && (
                          <p className='text-red-500 text-sm sm:text-sm md:text-base lg:text-base font-poppins'>
                            {states.errors.gst_number}
                          </p>
                        )}
                      </div>
                    )}
                  </>
                )}

                {/* Navigation Buttons */}
                <div className='flex justify-between mt-4 sm:mt-4 md:mt-6 lg:mt-6'>
                  <button
                    type='button'
                    onClick={handleBack}
                    disabled={states.step === 1}
                    className='bg-white border border-[#C12E2A] text-[#C12E2A] px-14 sm:px-14 md:px-24 lg:px-22 py-2 sm:py-2 md:py-2 lg:py-3 rounded-lg sm:rounded-lg md:rounded-xl xl:rounded-xl hover:bg-red-50 md:text-base font-poppins'
                  >
                    Back
                  </button>
                  {states.step < 3 ? (
                    <button
                      type='button'
                      onClick={handleNext}
                      className='bg-[#C12E2A] text-white px-14 sm:px-14 md:px-24 lg:px-22 py-2 sm:py-2 md:py-2 lg:py-3 rounded-lg sm:rounded-lg md:rounded-xl xl:rounded-xl hover:bg-red-700 md:text-base font-poppins'
                    >
                      Next
                    </button>
                  ) : (
                    <button
                      type='button'
                      onClick={handleSubmit}
                      className='bg-[#C12E2A] text-white px-11 sm:px-11 md:px-24 lg:px-22 py-2 sm:py-2 md:py-2 lg:py-3 rounded-lg sm:rounded-lg md:rounded-xl xl:rounded-xl hover:bg-red-700 md:text-base font-poppins'
                    >
                      Sign Up
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignUpPage;
